/* The Pillow Company Kids - cart insert offer handler (ported from The Pillow Company, 15 Oct 2026).
 * Loaded once from layout/theme.liquid: the cart drawer re-renders over AJAX and a <script> inside
 * injected markup never executes.
 * After a successful add we ask the theme drawer to refresh (cart:refresh). The refreshed markup is
 * rendered by the server with the insert already in the cart, so the offer row is gone for good.
 * The group stays locked until the theme publishes its cart update. If that never comes, or the add
 * fails, the page reloads: unknown cart state is never re-enabled.
 */
(function () {
  if (window.tpkCartInsertBound) return;
  window.tpkCartInsertBound = true;
  var pending = Object.create(null);

  function root() { return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; }
  function groupButtons(g, fb) {
    if (!g) return [fb];
    var l = document.querySelectorAll('.tpk-li[data-ci-group="' + g + '"] [data-ci-add]');
    return l.length ? l : [fb];
  }
  function clearGroup(g, row) {
    var rows = g ? document.querySelectorAll('.tpk-li[data-ci-group="' + g + '"]') : [];
    if (rows.length) { Array.prototype.forEach.call(rows, function (r) { r.remove(); }); }
    else if (row) { row.remove(); }
  }

  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('[data-ci-add]') : null;
    if (!btn || btn.disabled) return;
    var row = btn.closest('.tpk-li');
    var g = row ? row.getAttribute('data-ci-group') : null;
    if (g && pending[g]) { e.preventDefault(); return; }
    var id = parseInt(btn.getAttribute('data-variant'), 10);
    var qty = parseInt(btn.getAttribute('data-qty'), 10) || 1;
    if (!id) return;
    e.preventDefault(); e.stopPropagation();
    if (g) pending[g] = true;
    Array.prototype.forEach.call(groupButtons(g, btn), function (b) { b.disabled = true; });
    btn.textContent = 'Adding...';
    var onCartPage = document.body.classList.contains('cart-template') || /\/cart\/?$/.test(location.pathname);

    fetch(root() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: qty }] })
    })
      .then(function (r) { if (!r.ok) throw new Error('cart state unknown'); return r.json(); })
      .then(function () {
        clearGroup(g, row);
        if (onCartPage || !(window.FoxTheme && FoxTheme.pubsub)) { location.reload(); return; }
        var unsub, safety;
        unsub = FoxTheme.pubsub.subscribe(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, function () {
          clearTimeout(safety);
          if (typeof unsub === 'function') unsub();
          setTimeout(function () { clearGroup(g, null); if (g) delete pending[g]; }, 50);
        });
        safety = setTimeout(function () { if (typeof unsub === 'function') unsub(); location.reload(); }, 5000);
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { open: true } }));
      })
      .catch(function () {
        var note = row && row.querySelector('.tpk-li__note');
        if (note) note.textContent = 'Refreshing your bag...';
        location.reload();
      });
  }, true);
})();

/* "This is a gift" (snippets/tpk-cart-gift.liquid). Saves cart attributes Gift and Gift message.
 * Delegated on document because the drawer markup is replaced on every cart refresh; the server
 * re-renders the saved values, so nothing is kept in the page itself. */
(function () {
  if (window.tpkCartGiftBound) return;
  window.tpkCartGiftBound = true;
  var timer = null;

  function root() { return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; }
  function status(box, text) { var s = box && box.querySelector('[data-gift-status]'); if (s) s.textContent = text; }
  function save(box) {
    if (!box) return;
    var on = box.querySelector('[data-gift-toggle]').checked;
    var msg = box.querySelector('[data-gift-msg]').value || '';
    status(box, 'Saving...');
    fetch(root() + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ attributes: { 'Gift': on ? 'Yes' : '', 'Gift message': on ? msg : '' } })
    })
      .then(function (r) { if (!r.ok) throw new Error('not saved'); status(box, on ? 'Saved' : ''); })
      .catch(function () { status(box, 'Could not save. Please try again.'); });
  }

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.matches || !t.matches('[data-gift-toggle]')) return;
    var box = t.closest('[data-tpk-gift]');
    var panel = box && box.querySelector('[data-gift-panel]');
    if (panel) panel.hidden = !t.checked;
    if (t.checked) { var m = box.querySelector('[data-gift-msg]'); if (m) m.focus(); }
    save(box);
  });
  document.addEventListener('input', function (e) {
    var t = e.target;
    if (!t || !t.matches || !t.matches('[data-gift-msg]')) return;
    var box = t.closest('[data-tpk-gift]');
    clearTimeout(timer);
    timer = setTimeout(function () { save(box); }, 700);
  });
  document.addEventListener('focusout', function (e) {
    var t = e.target;
    if (!t || !t.matches || !t.matches('[data-gift-msg]')) return;
    clearTimeout(timer);
    save(t.closest('[data-tpk-gift]'));
  });
})();

/* Name embroidery fee (15 Oct 2026). Product "name-embroidery", variant id in window.tpkPzFee (layout/theme.liquid).
 * Rule: the fee quantity always equals the number of personalised units in the cart (lines carrying a
 * "Child Name" property). Checked after every add and every cart update; corrected only on a mismatch,
 * so the refresh it triggers settles on the next check. On any failure the page reloads. */
(function () {
  if (window.tpkPzFeeBound) return;
  window.tpkPzFeeBound = true;
  var busy = false, again = false, timer = null;
  function feeId() { return parseInt(window.tpkPzFee, 10) || 0; }
  function root() { return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; }
  function onCartPage() { return /\/cart\/?$/.test(location.pathname); }
  function post(url, body) {
    return fetch(root() + url, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { if (!r.ok) throw new Error('cart state unknown'); return r.json(); });
  }
  function reconcile(openDrawer) {
    var fee = feeId();
    if (!fee) return;
    if (busy) { again = true; return; }
    busy = true;
    fetch(root() + 'cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var need = 0, names = [], feeLines = [];
        cart.items.forEach(function (i) {
          if (i.variant_id === fee) { feeLines.push(i); return; }
          var n = i.properties && i.properties['Child Name'];
          if (n) { need += i.quantity; names.push(n); }
        });
        var have = feeLines.reduce(function (s, i) { return s + i.quantity; }, 0);
        if (have === need) return null;
        if (need === 0) {
          var u = {}; feeLines.forEach(function (i) { u[i.key] = 0; });
          return post('cart/update.js', { updates: u });
        }
        if (!feeLines.length) {
          return post('cart/add.js', { items: [{ id: fee, quantity: need, properties: { 'For': names.join(', ') } }] });
        }
        var u2 = {}; feeLines.forEach(function (i, k) { u2[i.key] = k === 0 ? need : 0; });
        return post('cart/update.js', { updates: u2 });
      })
      .then(function (changed) {
        if (!changed) return;
        if (onCartPage() || !(window.FoxTheme && FoxTheme.pubsub)) { location.reload(); return; }
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { open: !!openDrawer } }));
      })
      .catch(function () { location.reload(); })
      .finally(function () { busy = false; if (again) { again = false; schedule(false); } });
  }
  function schedule(open) { clearTimeout(timer); timer = setTimeout(function () { reconcile(open); }, 250); }
  document.addEventListener('product-ajax:added', function () { schedule(true); });
  function hook() {
    if (window.FoxTheme && FoxTheme.pubsub && FoxTheme.pubsub.PUB_SUB_EVENTS) {
      FoxTheme.pubsub.subscribe(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, function () { schedule(false); });
    }
    if (onCartPage()) schedule(false);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', hook); else hook();
})();
